import React, { useEffect, useState } from 'react';
import '../css/menu.css'
import MenuButton from './MenuButton';
import { homeIcon, patientsIcon, labsIcon, labtestIcon } from './Images';

const LeftMenu = ({active}) => {

    const [menuOptions, setMenuOptions] = useState([
        { image : homeIcon, url : '/home', name:'Inicio', active: false}
        ,{ image : patientsIcon, url : '/patients', name:'Pacientes', active: false}
        ,{ image : labsIcon, url : '/laboratorios', name:'Laboratorios', active: false}
        ,{ image : labtestIcon, url : '/lab-tests', name:'Pruebas de Laboratorio', active: false}
    ]);

    const updateActiveStatus = (name) => {
        const index = menuOptions.findIndex(option => option.name === name);
        const updatedMenuOptions = [...menuOptions];
        updatedMenuOptions[index] = { ...updatedMenuOptions[index], active: true };
        setMenuOptions(updatedMenuOptions);
    };

    useEffect(() => {
        updateActiveStatus(active);
    }, []);

    return (
        <div className='left-menu'>
            {menuOptions.map((item, index) => (
                <MenuButton key={index}
                    image={item.image} 
                    redirect={item.url} 
                    name={item.name}
                    active={item.active}
                />
            ))}
        
        </div>
    );
}

export default LeftMenu;
